// src/sim/foxguard/constants.ts — P3 foxguard tunable thresholds (GAME-13, GAME-14, GAME-15).
//
// Invariants:
//   - Tick-based (no milliseconds). Pixel-based distance/velocity where noted.
//   - All values P7-tunable per POL-06; retune if playtest shows > ~2 triggers
//     per 5-min round (Pitfall 9 warning sign).
//
// Source: .planning/phases/03-core-sim-primitives/03-CONTEXT.md D-15, D-16, D-17.

/** D-15 condition 1: look-back window counting a hunter as "recently involved" after dropping a hider off. 150 ticks = 5 s. TODO(P7 POL-06): retune from playtest. */
export const P3_FOXGUARD_RECENT_DROPOFF_TICKS = 150;

/** D-15 condition 2: distance-to-plinth cap in TILES (not pixels). 6 tiles ≈ 192 px at tileWidth=32. TODO(P7 POL-06): retune from playtest. */
export const P3_FOXGUARD_NEAR_BASE_TILES = 6;

/** D-15 condition 3: velocity cap in px/s. 32 ≈ ⅓ × P1_DEFAULT_BASE_SPEED (96). Loose threshold per D-16. TODO(P7 POL-06): retune from playtest. */
export const P3_FOXGUARD_VELOCITY_PX_PER_S = 32;

/** D-16: grace period — all 4 conditions must hold continuously this long to fire. 180 ticks = 6 s. User-selected looser than Pitfall-9's 8 s; TODO(P7 POL-06): retune from playtest if playtest shows > 2 triggers per 5-min round. */
export const P3_FOXGUARD_GRACE_TICKS = 180;

/** D-17: per-hider shout cooldown in ticks. 450 = 15 s. TODO(P7 POL-06): retune from playtest. */
export const P3_FOXGUARD_SHOUT_COOLDOWN_TICKS = 450;
